import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { manufacturerQuerySchema } from './manufacturer-query-schema';

export const manufacturerFormSchema = manufacturerQuerySchema
  .omit({ name: true, status: true, products_count: true, manufacturer_number: true })
  .extend({ name: z.string().min(3), status: statusFormSchema, manufacturer_number: z.string() });

export type ManufacturerFormSchema = z.infer<typeof manufacturerFormSchema>;
